import { createContext, useContext } from 'react';
import { ExperimentCreationModalContextState } from '../../types';

export const initialExperimentCreationModalContextState: ExperimentCreationModalContextState = {
  experimentTypes: [],
  isLoading: false,
  isError: false,
};

export const ExperimentCreationModalContext = createContext(
  initialExperimentCreationModalContextState,
);

export const useExperimentCreationModalContext = () => useContext(ExperimentCreationModalContext);
